//import React from 'react';

import React, { useState, useEffect } from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IconButton from "@material-ui/core/IconButton";
import ShareIcon from "@material-ui/icons/Share";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormLabel from "@material-ui/core/FormLabel";

import MoreVertIcon from "@material-ui/icons/MoreVert";

import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import TextField from "@material-ui/core/TextField";

export default function AutoPlaySettingsDialog(props) {
  var G_german_voice;
  var G_english_voice;
  var G_spanish_voice;
  var eng_found = false;
  var spa_found = false;
  var ger_found = false;

  var voices = speechSynthesis.getVoices();
  voices.forEach(function (voice, i) {
    if (voice.name.toLowerCase().indexOf("mex") != -1) {
      G_spanish_voice = voice.name;
      spa_found = true;
    } else if (voice.name.toLowerCase().indexOf("span") != -1 && !spa_found) {
      G_spanish_voice = voice.name;
    }

    if (voice.name.toLowerCase().indexOf("hedda") != -1) {
      G_german_voice = voice.name;
      ger_found = true;
    }
    if (voice.name.toLowerCase().indexOf("ger") != -1 && !ger_found) {
      G_german_voice = voice.name;
    } else if (voice.name.toLowerCase().indexOf("deu") != -1 && !ger_found) {
      G_german_voice = voice.name;
    }

    if (voice.name.toLowerCase().indexOf("eng") != -1) {
      if (voice.name.toLowerCase().indexOf("staat") != -1 && !eng_found) {
        G_english_voice = voice.name;
        eng_found = true;
      } else if (voice.name.toLowerCase().indexOf("stat") != -1 && !eng_found) {
        G_english_voice = voice.name;
        eng_found = true;
      } else if (voice.name.toLowerCase().indexOf("us") != -1 && !eng_found) {
        G_english_voice = voice.name;
        eng_found = true;
      }
      // else if(!eng_found) {
      //     G_english_voice = voice.name;
      //     eng_found=true;
      // }
    }
  });

  // alert(G_german_voice);
  //alert(G_english_voice);

  var voices = speechSynthesis.getVoices();
  var voice_names = [];

  voices.forEach(function (voice, i) {
    voice_names.push(voice.name);
  });

  const [open, setOpen] = React.useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  function handleSaveClose() {
    let autoPlaySettings = {};
    autoPlaySettings.Language1 = state.Language1;
    autoPlaySettings.Language2 = state.Language2;
    autoPlaySettings.Language3 = state.Language3;
    autoPlaySettings.Language4 = state.Language4;
    autoPlaySettings.Language5 = state.Language5;
    autoPlaySettings.Description1 = state.Description1;
    autoPlaySettings.Description2 = state.Description2;
    autoPlaySettings.Description3 = state.Description3;
    autoPlaySettings.Description4 = state.Description4;
    autoPlaySettings.Description5 = state.Description5;
    autoPlaySettings.SpeakOnNavigation = state.SpeakOnNavigation;
    autoPlaySettings.Verzug = state.Verzug;
    autoPlaySettings.Order = state.Order;
    autoPlaySettings.Level = state.Level;

    // props.handleSettingsChanged(state.Right,state.Left,state.Up,state.Down,state.SpanishVoice,state.GermanVoice,state.EnglishVoice);
    props.handleAutoPlaySettingsChanged(autoPlaySettings);
    setOpen(false);
  }

  const [state, setState] = React.useState(props.autoPlaySettings);

  // const [state, setState] = React.useState({
  //   Language1:false,
  //   Language2:false,
  //   Language3:false,
  //   Language4:true,
  //   Language5:false,
  //   Description1:false,
  //   Description2:false,
  //   Description3:false,
  //   Description4:false,
  //   Description5:false,
  //   Verzug:3,
  //   Order:"Asc",
  //   Level:1
  // });

  // const handleChangeRadio = event => {
  // //  setValue(event.target.value);
  //   setState({ ...state, [name]: event.target.checked });
  // };
  const handleChangeRadio = (name) => (event) => {
    setState({ ...state, [name]: event.target.value });
  };

  const handleChange = (name) => (event) => {
    setState({ ...state, [name]: event.target.checked });
  };

  const handleChangeText = (name) => (event) => {
    setState({ ...state, [name]: event.target.value });
  };

  const handleChangeSelect = (name) => (event) => {
    if (name == "LanguageUsed") {
      if (event.target.value == "Spanish") {
        setState({
          ...state,
          [name]: event.target.value,
          ["Right"]: "Language1",
          ["Left"]: "Language1",
          ["Down"]: "Language1",
          ["Up"]: "Language2",
        });
      }
      if (event.target.value == "German") {
        setState({
          ...state,
          [name]: event.target.value,
          ["Right"]: "Language2",
          ["Left"]: "Language2",
          ["Down"]: "Language2",
          ["Up"]: "Language1",
        });
      }
    } else {
      setState({ ...state, [name]: event.target.value });
    }
  };

  useEffect(() => {});

  return (
    <div>
      <IconButton aria-label="Share" onClick={handleClickOpen}>
        <MoreVertIcon />
      </IconButton>

      <Dialog
        fullWidth="sm"
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Settings33"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Auto play settings
          </DialogContentText>

          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.Language1}
                  onChange={handleChange("Language1")}
                  value="Language1"
                />
              }
              label="Language1"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.Language2}
                  onChange={handleChange("Language2")}
                  value="Language2"
                />
              }
              label="Language2"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.Language3}
                  onChange={handleChange("Language3")}
                  value="Language3"
                />
              }
              label="Language3"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.Language4}
                  onChange={handleChange("Language4")}
                  value="Language4"
                />
              }
              label="Language4"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.Language5}
                  onChange={handleChange("Language5")}
                  value="Language5"
                />
              }
              label="Language5"
            />
          </FormGroup>

          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.Description1}
                  onChange={handleChange("Description1")}
                  value="Description1"
                />
              }
              label="Description1"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.Description2}
                  onChange={handleChange("Description2")}
                  value="Description2"
                />
              }
              label="Description2"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.Description3}
                  onChange={handleChange("Description3")}
                  value="Description3"
                />
              }
              label="Description3"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.Description4}
                  onChange={handleChange("Description4")}
                  value="Description4"
                />
              }
              label="Description4"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.Description5}
                  onChange={handleChange("Description5")}
                  value="Description5"
                />
              }
              label="Description5"
            />
          </FormGroup>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.SpeakOnNavigation}
                  onChange={handleChange("SpeakOnNavigation")}
                  value="SpeakOnNavigation"
                />
              }
              label="Speak on Navigation"
            />
          </FormGroup>

          <RadioGroup
            row
            aria-label="gender"
            name="gender1"
            value={state.Order}
            onChange={handleChangeRadio("Order")}
          >
            <FormControlLabel value="Asc" control={<Radio />} label="Asc" />
            <FormControlLabel value="Desc" control={<Radio />} label="Desc" />
          </RadioGroup>

          <RadioGroup
            row
            aria-label="gender"
            name="Levels"
            value={state.Level}
            onChange={handleChangeRadio("Level")}
          >
            <FormControlLabel value="1" control={<Radio />} label="1" />
            <FormControlLabel value="2" control={<Radio />} label="2" />
            <FormControlLabel value="3" control={<Radio />} label="3" />
            <FormControlLabel value="4" control={<Radio />} label="4" />
            <FormControlLabel value="5" control={<Radio />} label="5" />
            <FormControlLabel value="6" control={<Radio />} label="6" />
            <FormControlLabel value="7" control={<Radio />} label="7" />
          </RadioGroup>

          <TextField
            fullWidth
            id="Verzug"
            label="Verzug"
            className="Verzug"
            value={state.Verzug}
            onChange={handleChangeText("Verzug")}
            margin="normal"
            max-width="100px"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Disagree
          </Button>
          <Button onClick={handleSaveClose} color="primary" autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
